export const Providers = {
  CEMEX: 'CEMEX',
  CEMOSA: 'CEMOSA',
};

export const ProviderTypes = {
  CONCRETE: 'concrete',
  LABORATORY: 'laboratory',
};
